export default __webpack_public_path__ + "static/media/Sort-Default.0eb3d5de.svg";